module.exports = __webpack_public_path__ + "img/mic.365d04e9.svg";